module.exports = __webpack_public_path__ + "static/media/mute_splash.c28819c2.png";